import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import {
  PayoutResponse,
  PayoutRequest,
  PayoutHistory,
  PayoutMethod,
  PayoutMethodRequest,
  PayoutBalance,
  PayoutHistoryRequest,
  Payout,
} from '../models';

export interface FinanceWebmasterProvider {
  getPayouts(filters: string): Observable<PayoutResponse>;
  getPayout(payoutId: number): Observable<Payout>;
  makePayout(request: PayoutRequest): Observable<void>;
  getPayoutsHistory(request: PayoutHistoryRequest): Observable<PayoutHistory[]>;
  getPayoutsMethod(): Observable<PayoutMethod[]>;
  sendPayoutMethod(request: PayoutMethodRequest): Observable<void>;
  deletePayoutMethod(id: number): Observable<void>;
  setActivePayoutMethod(id: number, isActive: boolean): Observable<void>;
  getMyBalance(): Observable<PayoutBalance>;
  getPayoutsCSV(filters?: string): Observable<Response>;
}

export const FINANCE_WEBMASTER_PROVIDER_TOKEN = new InjectionToken<FinanceWebmasterProvider>(
  'FinanceWebmaster',
);
